import "jquery-breakpoints";

class Breakpoints {
  constructor() {
    this.window = $(window);

    this.init();
  }

  init() {
    this.window.breakpoints({
      triggerOnInit: true,
      breakpoints: [
        {
          name: "xs",
          width: 0,
        },
        {
          name: "sm",
          width: 576,
        },
        {
          name: "md",
          width: 768,
        },
        {
          name: "lg",
          width: 1025,
        },
        {
          name: "xl",
          width: 1200,
        },
      ],
    });

    let currentBreakpoint = this.window.breakpoints("getBreakpoint");
    document.body.classList.add("breakpoint-" + currentBreakpoint);

    this.window.on("breakpoint-change", this.breakPointChange.bind(this));
  }

  breakPointChange() {
    this.window.breakpoints("greaterEqualTo", "lg", function () {
      document.body.classList.add("b--desktop");
      document.body.classList.remove("b--responsive");
    });

    this.window.breakpoints("lessThan", "lg", function () {
      document.body.classList.remove("b--desktop");
      document.body.classList.add("b--responsive");
    });
  }
}

export default Breakpoints;
